import Api from '../api';

/**
 * Registra uma mensagem do chat no backend
 * @param {string} message - Conteúdo da mensagem
 * @returns {Promise<void>}
 */
export const registerChatMessage = async (message) => {
  try {
    await Api.post('/api/chat/register-message', { message });
  } catch (error) {
    // Não bloquear o fluxo se o registro falhar
    console.warn('Erro ao registrar mensagem do chat:', error);
  }
};

/**
 * Verifica se pode enviar mensagem (verifica limite)
 * @returns {Promise<{canSendMessage: boolean, currentCount: number, limit: number, remaining: number, warningThreshold: boolean}>}
 */
export const checkChatLimit = async () => {
  try {
    const response = await Api.get('/api/chat/check-limit');
    return response.data;
  } catch (error) {
    console.error('Erro ao verificar limite do chat:', error);
    // Em caso de erro, permitir enviar (fail-safe)
    return {
      canSendMessage: true,
      currentCount: 0,
      limit: 100,
      remaining: 100,
      warningThreshold: false
    };
  }
};

